import {mapState} from "vuex";

export default {
    data() {
        return {
            cancel: false
        }
    },
    computed: {
        step() {
            return this.$store.getters['ui/step'](this.$route.name);
        },
        displayStep() {
            return this.step + 1;
        },
        wizardType() {
            return this.$store.getters['ui/wizardType'](this.$route.name);
        },
        wizardEntryPoint() {
            return this.$store.getters['ui/wizardEntryPoint'](this.$route.name);
        },
        currentWizard() {
            return this.wizards[this.wizardType];
        },
        isLastStep() {
            return this.$store.getters['ui/nextStep'](this.$route.name) == null;
        },
        ...mapState('ui',['wizard', 'wizards', 'drawerHidden', 'lastEditableStep'])
    },
    methods: {
        nextStep(params) {
            let name = this.$store.getters['ui/nextStep'](this.$route.name);
            let route;
            if(name === true) {
                route = this.wizardEntryPoint;
            } else {
                let p = params || this.wizardParams;
                route = { name, params: p };
            }
            this.$router.push(route);
        },
        changeStep(event, params) {
            let p = params || this.wizardParams;
            var route = { name: this.wizards[this.wizardType][event.index].route, params: p };
            this.$router.push(route);
        },
        cancelWizard() {
            //var route = { name };
            // save before leave
            /*
            if(!discard && this.save && typeof(this.save) === 'function') {
                await this.save();
            }
            */
            var route = this.wizardEntryPoint;
            console.debug(`cancel called, going to route`, route);
            this.cancel = true;
            this.$router.push(route);
        },

        cancelWizardR(to) {
            let newWizard = this.$store.getters['ui/wizardType'](to.name);
            let exitingWizard = newWizard != this.wizardType && this.wizardType != null;
            //console.debug('sameWizard', sameWizard);
            if(this.cancel || exitingWizard) {
                this.$store.commit('ui/dynamicEntryPoint', {value: null});
                this.$store.commit('ui/wizard', {value: false});
            }
        },

        exitWizard() {
            console.debug('Exiting wizard...');
            this.$store.commit('ui/dynamicEntryPoint', {value: null});
            if(this.wizard) {
                this.$store.commit('ui/wizard', {value: false});
            }
        },
        wizardLifecycleControl() {
            console.debug('Wizard lifecycle control:');
            //if(this.wizard && this.drawerHidden && !this.isLastStep) {
                //console.debug('entering wizard...');
                
                setTimeout(() => { 
                    console.debug(`Checking drawer state: ${this.wizard} ${this.drawerHidden} ${this.drawer}`); 
                    if(this.wizard && this.drawerHidden && !this.isLastStep && this.drawer) { 
                        console.debug('Hiding drawer...'); this.drawer = false; 
                    } 
                }, 500);
            //}
            /*
            else if(this.wizard && this.isLastStep) {
                console.debug('last step, exiting...');
                this.exitWizard();
            }
            */
        },
        setLastEditableStep() {
            if(!this.lastEditableStep || this.lastEditableStep < this.step) {
                this.$store.commit('ui/lastEditableStep', { value: this.step });
            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.cancelWizardR(to);    
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.cancelWizardR(to);    
        next();
    },
}